export const agataStark = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta młodzieży Agata Stark • COLLIGO',
        'description': 'Jestem psychologiem i psychoterapeutą poznawczym Instrumental Enrichment. Prowadzę konsultacje oraz terapię indywidualną dzieci, młodzieży oraz dorosłych.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-agata-stark/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/agata-stark.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Toruniu, Psychoterapeuta w Toruniu Agata Stark'
        }
    }
}